// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"5957":"PreviewButton","8086":"components-payment","9777":"recorder"}[chunkId] || chunkId) + ".js";
};